export default __webpack_public_path__ + "images/7f568616a756f7a7167d3096e813d3a9-understanding_how_to_care_for_someone_with_cognition_impairments.svg";